import { ReactNode } from 'react';
import { Flex, Text } from '@coverflex-tech/hypernova';
import { css } from './LearningCentreMethod.css';

export const LearningCentreMethod = ({
  icon,
  title,
  children,
}: TLearningCentreMethodProps) => {
  return (
    <Flex flexDirection="column" gap="md" className={css.root}>
      <Flex gap="sm" alignItems="center">
        {icon}
        <Text bold>{title}</Text>
      </Flex>
      <Text>{children}</Text>
    </Flex>
  );
};

export type TLearningCentreMethodProps = {
  icon: ReactNode;
  title: ReactNode;
  children: ReactNode;
};
